export const createRole = /* GraphQL */ `
  mutation CreateRole(
    $input: CreateRoleInput!
    $authorizationContext: AuthorizationContextInput!
  ) {
    createRole(input: $input, authorizationContext: $authorizationContext) {
      id
      sk
    }
  }
`;

export const createRoleSecure = /* GraphQL */ `
  mutation CreateRoleSecure(
    $input: CreateRoleInput!
    $authorizationContext: AuthorizationContextInput!
  ) {
    createRoleSecure(input: $input, authorizationContext: $authorizationContext)
  }
`;

export const updateRole = /* GraphQL */ `
  mutation UpdateRole(
    $input: UpdateRoleInput!
    $authorizationContext: AuthorizationContextInput!
  ) {
    createRole(input: $input, authorizationContext: $authorizationContext) {
      id
      sk
    }
  }
`;

export const deleteRole = /* GraphQL */ `
  mutation DeleteRole(
    $input: DeleteRoleInput!
    $authorizationContext: AuthorizationContextInput!
  ) {
    createRole(input: $input, authorizationContext: $authorizationContext) {
      id
      sk
    }
  }
`;

export const createRolePolicy = /* GraphQL */ `
  mutation CreateRolePolicy(
    $input: CreateRolePolicyInput!
    $authorizationContext: AuthorizationContextInput!
  ) {
    createRolePolicy(
      input: $input
      authorizationContext: $authorizationContext
    ) {
      id
      sk
    }
  }
`;

export const updateRolePolicy = /* GraphQL */ `
  mutation UpdateRolePolicy(
    $input: UpdateRolePolicyInput!
    $authorizationContext: AuthorizationContextInput!
  ) {
    updateRolePolicy(
      input: $input
      authorizationContext: $authorizationContext
    ) {
      id
      sk
    }
  }
`;
